import { createApp } from 'vue'
import App from './App.vue'
// styles the vueform class keys the shared MultiSelect does not override
import '@vueform/multiselect/themes/tailwind.css'
import router from './router'
import store from './store'
import { EventsPlugin } from './plugins'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(createPinia())
app.use(EventsPlugin)
app.use(VueQueryPlugin)

app.mount('#app')
